// Export selectors
export const selectTaxPaymentPeriods = (state) => state.tax.taxPaymentPeriods
export const selectIsGetTaxPaymentPeriodsInProgress = (state) =>
    state.tax.isGetTaxPaymentPeriodsInProgress
export const selectIsGetTaxPaymentPeriodsSuccess = (state) =>
    state.tax.isTaxPaymentPeriodsSuccess
export const selectIsGetTaxPaymentPeriodsErrorMsg = (state) =>
    state.tax.taxPaymentPeriodsErrorMsg
export const selectTaxSteps = (state) => state.tax.taxSteps

export const selectCalculatedTaxData = (state) => state.tax.calculatedTaxData
export const selectCalculatedTaxInProgress = (state) => state.tax.isCalculateTaxInProgress
export const selectCalculatedTaxSuccess = (state) => state.tax.isCalculateTaxSuccess
export const selectCalculateTaxErrorMsg = (state) => state.tax.calculatedTaxErrorMsg

export const selectPreSelectedTaxPeriod = (state) => state.tax.preSelectedPeriod

export const selectTaxFlowData = (state) => state.tax.taxFlowData

